import { render, staticRenderFns } from "./AbilityTraining.vue?vue&type=template&id=45c4acb2"
import script from "./AbilityTraining.vue?vue&type=script&lang=js"
export * from "./AbilityTraining.vue?vue&type=script&lang=js"
import style0 from "./AbilityTraining.vue?vue&type=style&index=0&id=45c4acb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports